import type { DeviceSync } from "@workspace/api-client-react";

/** Buffer before urlExpiresAt to trigger a sync refresh (default 10 min). */
export const URL_REFRESH_BUFFER_MS = 10 * 60_000;

/** Return ms until the earliest presigned URL expires, or null if none expire. */
export function msUntilEarliestUrlExpiry(
  sync: DeviceSync | null | undefined,
  bufferMs = URL_REFRESH_BUFFER_MS,
): number | null {
  if (!sync) return null;
  const now = Date.now();
  let earliest: number | null = null;

  for (const playlist of sync.playlists) {
    for (const item of playlist.items) {
      if (!item.urlExpiresAt) continue;
      const expires = new Date(item.urlExpiresAt).getTime();
      if (!Number.isFinite(expires)) continue;
      const remaining = expires - now - bufferMs;
      if (earliest === null || remaining < earliest) {
        earliest = remaining;
      }
    }
  }
  return earliest;
}

/** True when any referenced media URL is expired or within the refresh buffer. */
export function syncNeedsUrlRefresh(
  sync: DeviceSync | null | undefined,
  bufferMs = URL_REFRESH_BUFFER_MS,
): boolean {
  const ms = msUntilEarliestUrlExpiry(sync, bufferMs);
  return ms !== null && ms <= 0;
}
